import React from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, Grid } from '@mui/material'
import Card from '@mui/material/Card'
import PropTypes from 'prop-types'
import CardContent from '@mui/material/CardContent'

import { CardHeader } from '~/components/Cards'
import PageTitle from '~/components/PageTitle'
import Container, { Content, Header } from '~/components/Container'
import { withForm } from '~/components/Form'
import { DiscardButton } from '~/components/Buttons'
import * as NAV from '~/constants/nav-titles'
import TextField from '~/components/Fields/TextField'
import WarehouseSearchField from '~/components/Fields/WarehouseSearchField'
import * as API from '~/constants/api'

import MovementSummary from '../../components/MovementSummary'
import LineItems from '../MovementBrowseCreate/LineItems'
import MovementUpdateButton from '../MovementUpdateButton'

function MovementBrowseUpdateForm (props) {
  const { t } = useTranslation()
  const {
    form,
    pageTitle,
    pageTitleLoading,
    isLoading,
    movementUnitList
  } = props

  const { handleSubmit } = form

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <Header>
          <PageTitle
            parentTitle={NAV.MOVEMENT}
            pageTitleLoading={pageTitleLoading}
            pageTitle={pageTitle}
            rightButton={
              <>
                <DiscardButton />
                <MovementUpdateButton
                  isLoading={isLoading}
                  onSubmit={handleSubmit}
                />
              </>
            }
          />
        </Header>

        <Content>
          <Grid container={true} spacing={3}>
            <Grid item={true} lg={4}>
              <Card>
                <CardHeader title={t('Move in')} />
                <Divider />
                <CardContent>
                  <Grid container={true} spacing={3}>
                    <Grid item={true} lg={12}>
                      <WarehouseSearchField api={API.WAREHOUSE_LIST} required={true} />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item={true} lg={12}>
              <Card>
                <CardHeader title={t('Stock')} required={true} />
                <Divider />
                <LineItems movementUnitList={movementUnitList} />
              </Card>
            </Grid>
            <Grid item={true} lg={12}>
              <Grid container={true} spacing={3}>
                <Grid item={true} lg={6}>
                  <Card>
                    <CardHeader title={t('Summary')} />
                    <Divider />
                    <MovementSummary />
                  </Card>
                </Grid>
                <Grid item={true} lg={6}>
                  <Card>
                    <CardHeader title={t('Notes')} />
                    <Divider />
                    <CardContent>
                      <TextField
                        label="Notes"
                        name="notes"
                        multiline={true}
                        minRows={11}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Container>
    </form>
  )
}

MovementBrowseUpdateForm.propTypes = {
  pageTitle: PropTypes.object,
  pageTitleLoading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  movementUnitList: PropTypes.object.isRequired
}

export default withForm(MovementBrowseUpdateForm)
